import { render, staticRenderFns } from "./nsitf-report.vue?vue&type=template&id=3622dd02&"
import script from "./nsitf-report.vue?vue&type=script&lang=js&"
export * from "./nsitf-report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports